var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxUncheckDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4228 3.84492C35.7739 3.13583 43.4124 5.27151 47.7976 8.70209C52.1829 12.1327 55.8258 18.5611 56.7343 24.4284C57.6427 30.2957 56.1586 38.8412 53.2484 43.9058C50.3381 48.9705 44.369 52.8244 39.2727 54.8161C34.1765 56.8078 27.8859 57.6719 22.6706 55.8559C17.4554 54.0399 10.8845 48.7643 7.98108 43.9202C5.0777 39.076 4.22138 32.3235 5.25036 26.7913C6.27935 21.259 8.89268 14.3442 14.155 10.7267C19.4173 7.10914 31.8497 5.70168 36.8244 5.08608C41.799 4.47048 44.0227 6.62505 44.0032 7.03308M26.7615 4.18984C32.2486 3.21789 41.1669 5.28986 45.8905 8.26296C50.614 11.2361 53.5778 16.5592 55.1028 22.0284C56.6278 27.4976 57.1915 35.9685 55.0405 41.0783C52.8896 46.1881 47.3892 50.0719 42.1971 52.6874C37.0049 55.3029 29.1242 57.7753 23.8878 56.7713C18.6513 55.7673 14.2594 51.4402 10.7784 46.6636C7.29737 41.8871 2.90516 33.7068 3.00156 28.112C3.09796 22.5173 7.33735 17.1444 11.3568 13.0951C15.3763 9.04584 24.569 5.38741 27.1183 3.81636C29.6676 2.24532 26.6278 3.37215 26.6525 3.66886",
    stroke: "#B0B0B0",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxUncheckDisable);
export default __webpack_public_path__ + "static/media/check-box-uncheck-disable.8313b5e0e06628e47f040e7b1709ddfa.svg";
export { ForwardRef as ReactComponent };